






import { ref, computed, defineComponent, onMounted } from '@vue/composition-api';

export default defineComponent({
    name: "qa-tips", // ICP备案主页面
    components: {

    },
    props: {
        tips: {
            type: String,
            default: ''
        },
    }
})
